module.exports = __webpack_public_path__ + "static/media/masked-pipes-small.cc8293fa.gif";